import {v4 as uuidv4} from 'uuid';
import {logInfo} from "../../components/model/utils";
import {deleteCache, getObjectFromCache, saveObjectToCache} from "./DataCache";

export function testProfileLogic()
{
    let profile = getProfile()
    if (profile.profileId.length < 5)
        throw Error("Something went wrong! Profile empty!")
    let profileId = profile.profileId
    /*
    removeProfile()
    if (getProfile().profileId === profileId)
        throw Error("profileId should change!")
    getProfile().customerId = "test@duoclassico.eu"
    saveProfile()
    if (getProfile().customerId !== "test@duoclassico.eu")
        throw Error("profile not saved!")

     */
}

export function getProfile() {
    if (profilePrivate !== undefined && profilePrivate.profileId !== undefined && profilePrivate.profileId.length > 5)
        return profilePrivate
    loadOrInitProfile()
    return profilePrivate
}
export function saveProfile()
{
    saveObjectToCache(storageCacheKey, cacheObjKey, profilePrivate)
}
export function removeProfile() {
    deleteCache(storageCacheKey)
    logInfo("Profile removed " + profilePrivate.profileId)
    loadOrInitProfile();
}

///----Implementation-----

let storageCacheKey = "NEVEREXPIRED"
let cacheObjKey = "userProfile"

let initial = {
    firstEntryPath:undefined,
    profileId: unescape,
    customerId:"",
    customerName:"",
    customerPhone:"",
    leadId:undefined
}
let profilePrivate

function loadOrInitProfile()
{
    let state1 = getObjectFromCache(storageCacheKey, cacheObjKey)
    if (state1 !== undefined && state1 !== null && state1.profileId !== undefined && state1.profileId.length > 1)
        profilePrivate = state1
    else
        createProfile()
}

function createProfile() {
    profilePrivate = initial
    profilePrivate.profileId = uuidv4()
    saveProfile()
    logInfo("New profile created:" + profilePrivate.profileId)
}


